import { render, staticRenderFns } from "./ConfiguraCampos.vue?vue&type=template&id=7c46ffea&scoped=true"
import script from "./ConfiguraCampos.vue?vue&type=script&lang=js"
export * from "./ConfiguraCampos.vue?vue&type=script&lang=js"
import style0 from "./ConfiguraCampos.vue?vue&type=style&index=0&id=7c46ffea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46ffea",
  null
  
)

export default component.exports